import { createFileRoute } from "@tanstack/react-router"
import { PromptExperimentSheet } from "modules/backoffice/components/experiments/PromptExperimentSheet"

export const Route = createFileRoute(
  "/_base/_auth/backoffice/conversationExperiments/list/prompt-experiment",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()

  return (
    <PromptExperimentSheet
      onClose={() =>
        navigate({
          to: "/backoffice/conversationExperiments/list",
          search,
        })
      }
    />
  )
}
